import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';

import { entityType, connectedDictionaryType, dictionaryType } from 'types';

import ConnectedDictionariesList from './components/ConnectedDictionariesList';
import './style.scss';

const EntityInspectContent = ({
  currentEntity,
  items,
  onConnect,
  getAllDictionaries,
  allDictionaries,
  isLoadingAllDictionaries,
  formValues,
}) => (
  <div styleName="dictionary-connections" data-test="entity-inspect-content">
    <FieldArray
      name="dictionary_connections"
      component={ConnectedDictionariesList}
      currentEntity={currentEntity}
      items={items}
      onConnect={onConnect}
      allDictionaries={allDictionaries}
      getAllDictionaries={getAllDictionaries}
      isLoadingAllDictionaries={isLoadingAllDictionaries}
      formValues={formValues}
    />
  </div>
);

EntityInspectContent.propTypes = {
  /* eslint-disable react/no-typos */
  currentEntity: entityType.isRequired,
  isLoadingAllDictionaries: PropTypes.bool,
  items: PropTypes.arrayOf(connectedDictionaryType).isRequired,
  allDictionaries: PropTypes.arrayOf(dictionaryType).isRequired,
  onConnect: PropTypes.func.isRequired,
  getAllDictionaries: PropTypes.func.isRequired,
  formValues: entityType,
};

export default EntityInspectContent;
